<template>
    <body :class="[isOverlay ? 'active' : '']">
        <Header :menu="menu" @update-overlay="updateOverlay"/>
        <Trail :trail="trail"/>
        <transition name="fade">
            <router-view v-on:update-trail="updateTrail" :key="$route.fullPath" :programs="isHomePage ? programs : undefined">
                <!-- :key="$route.fullPath" para forzar el redibujado de la vista: no cambiaba la vista cuando iba de /programa/0068 a /programa/0137 -->
                <template v-slot:sidebar>                    
                    <Sidebar :sidebar="sidebar" />
                </template>
            </router-view>
        </transition>
        <Footer />
    </body>
</template>

<script>
    /* import components */
    import Header from "@/components/Header.vue"; 
    import Trail from "@/components/Trail.vue"; 
    import Sidebar from "@/components/Sidebar.vue";
    import Footer from "@/components/Footer.vue"; 
 
    /* import data */
    import { getTrail, getMenu } from "@/data-interface.js";  
    import { getPrograms } from "@/api.js"
    export default {
        name: "app",
        components: {
            Header,
            Trail,
            Sidebar,
            Footer,
        }, 
        data () {
            return {
                isOverlay: false,
                menu: [],
                trail: {},
                sidebar: [],
                programs: [],
                isHomePage: false,
            }
        },
        created () {
            this.getData();
            this.menu = getMenu();
            this.trail = getTrail();
            this.updateTrail();
        },
        methods: {
            updateTrail(to = this.$route) {
                to.name == "Programa" ? this.$set(this.trail.dynamic, 1, { tag: to.params.code } ) : this.trail.dynamic.splice(1, 1);
            }, 
            updateOverlay(active){
                this.isOverlay = active
            },
            async getData() {
                let menuItem = {
                    tag: "Programas Presupuestales",
                    name: "pprs",
                    children: []
                }
                await getPrograms().then(data => {
                    this.programs = data;
                    const map = new Map();
                    for (const program of data) {
                        if(!map.has(program.code)){
                            map.set(program.code, true);
                            let item = {
                                tag: `Programa Presupuestal ${program.code}`, 
                                path: `/programa/${program.code}`,
                                name: `ppr${program.code}`
                            } 
                            this.sidebar.push(item);
                            menuItem.children.push(item)                 
                        }
                    }
                    this.menu.push(menuItem)
                })
            },
        },
        watch: {
            $route(to) {
                this.updateTrail(to);
                to.name == "Home" ? this.isHomePage = true : this.isHomePage = false;
            }
        }
    }    
</script>
<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition-property: opacity;
        transition-duration: .25s;
    }

    .fade-enter-active {
        transition-delay: .25s;
    }

    .fade-enter, .fade-leave-active {
        opacity: 0
    }
</style>